import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                 */
const IconTrigger = ({ "aria-label": ariaLabel, onClick, name }) => {
  const [isActive, setIsActive] = React.useState(false);
  const handleTriggerMouseOver = React.useCallback(() => {
    setIsActive(true);
  }, [setIsActive]);
  const handleTriggerMouseLeave = React.useCallback(() => {
    setIsActive(false);
  }, [setIsActive]);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-label": ariaLabel,
      className: "icon-trigger",
      onClick,
      onMouseOver: handleTriggerMouseOver,
      onMouseLeave: handleTriggerMouseLeave,
      onFocus: () => null
    },
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        width: 18,
        height: 18,
        className: classnames({ "icon-trigger__icon--hidden": isActive }),
        name
      }
    ),
    /* @__PURE__ */ React.createElement(
      Icon,
      {
        width: 18,
        height: 18,
        className: classnames({ "icon-trigger__icon--hidden": !isActive }),
        name: `${name}-filled`
      }
    )
  );
};
export {
  IconTrigger
};
//# sourceMappingURL=IconTrigger.js.map
